import TonWeb from 'tonweb';

const Address = TonWeb.utils.Address;

export const standardizeTonAddress = (address: string) => {
  return new Address(address).toString(true, true);
};
